import { render, staticRenderFns } from "./WeightBaseRate.vue?vue&type=template&id=17a54d4c&"
import script from "./WeightBaseRate.vue?vue&type=script&lang=js&"
export * from "./WeightBaseRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports